import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { TranslationsProvider, Translations } from '@teliaee/telia-translate';
import config from '../config';
import LanguageStore from '../stores/LanguageStore';
import { useStores } from '../stores/RootStore';

interface Props {
  children?: React.ReactChild | React.ReactChild[];
  languageStore?: LanguageStore;
  translations: Translations;
}

const TranslationsContextWrapper: React.FC<Props> = inject('languageStore')(
  observer((props: Props): JSX.Element => {
    const { app } = useStores();
    const lang = props.languageStore.currentLanguage;
    return (
      <TranslationsProvider
        translations={props.translations}
        tier={config.environment}
        lang={lang}
        defaultApp={`${app}web`}
        includeGlobalTranslations={false}
        labelsUrl={`${config[app].webUrl}/api/translations/${lang}?app=${app}`}
        disableStatistics={!config.enableLabelStatistics}
      >
        {props.children}
      </TranslationsProvider>
    );
  })
);
export default TranslationsContextWrapper;
